import { judgeCanUseDeepLink, getAppType, showLog, parseObjectProtocol, getOSType, openDeepLink, openTencentStore, openSchema, WEIXIN_APPID, openTransitionPage, reportVisitAction, reportClickOpen, isDev } from './util';

const osType = getOSType();

function weixinCallback(protocolObject) {
  if (osType == 'iOS') {
    openDeepLink(protocolObject);
  } else {
    openTencentStore(protocolObject);
  }
}

function qqCallback(protocolObject) {
  if (osType == 'iOS') {
    // TODO iOS的应用宝当前无法完全保证顺利跳转，需要iOS定位问题或者调研豆瓣deeplink方案，暂时回退中转页方案
    openTransitionPage(protocolObject);
  } else {
    openTencentStore(protocolObject);
  }
}

function weiboCallback(protocolObject) {
  openTransitionPage(protocolObject, osType);
}

function otherCallback(protocolObject) {
  if (isDev()) {
    console.log('invoke otherCallback', protocolObject);
    return;
  }
  if (osType == 'iOS') {
    openDeepLink(protocolObject);
  } else {
    openSchema(protocolObject);
    setTimeout(() => {
      openTencentStore(protocolObject);
    }, 2000);
  }
}

/**
 * 动态设置微信开放标签的 extinfo
 */
function setOpenTagExtinfo(el, protocolObject) {
  const launchBtn = el.querySelector('wx-open-launch-app');
  if (!launchBtn) return;
  const extinfo = JSON.stringify({
    protocol: `heybox://${encodeURIComponent(JSON.stringify(protocolObject))}`,
  });
  launchBtn.setAttribute('extinfo', extinfo);
}

/**
 * 应用微信开放标签
 */
function registerWeixinOpenTag(el) {

  const elPosition = window.getComputedStyle(el).position;
  if (elPosition === 'static') {
    el.style.position = 'relative';
  }

  const launchBtn = document.createElement('wx-open-launch-app');

  // 设置 attributes
  launchBtn.setAttribute('appid', WEIXIN_APPID);

  // 设置 template
  const template = document.createElement('script');
  template.setAttribute('type', 'text/wxtag-template');
  template.innerHTML = `
      <style>
        .wx-open-launch-btn {
          width: 9999px;
          height: 9999px;
          background-color: red;
          opacity: 0;
        }
      </style>
      <button class="wx-open-launch-btn"></button>
    `;
  launchBtn.appendChild(template);

  // 设置样式
  launchBtn.style.cssText = `
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 50;
      background: blue;
      opacity: 0;
      border-radius: inherit;
      overflow: hidden;
    `;

  let isReady = false;
  // 设置事件处理
  launchBtn.addEventListener('ready', () => {
    showLog('ready');
    el.dispatchEvent(new CustomEvent('launch:ready'));
    isReady = true;
  });

  launchBtn.addEventListener('launch', () => {
    console.log(launchBtn.getAttribute('extinfo'));
    showLog('launch');
    el.dispatchEvent(new CustomEvent('launch:success'));
  });

  // 回退兼容
  const fallback = () => {
    if (osType == 'iOS') {
      openDeepLink(el._openProtocolObject);
    } else {
      openTencentStore(el._openProtocolObject);
    }
  }

  document.addEventListener('WeixinOpenTagsError', function (e) {
    console.error(e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
    fallback();
  });

  // INFO 开放标签不可用时
  launchBtn.addEventListener('error', () => {
    showLog('error');
    el.dispatchEvent(new CustomEvent('launch:error'));
    fallback();
  });

  el.appendChild(launchBtn);

  launchBtn.addEventListener('click', (e) => {
    showLog('launchBtn click');
    e.stopPropagation();
    reportClickOpen(el._openProtocolObject);
    // NOTE 微信开放平台未配置白名单等导致开放标签不可用时，需要回退兼容，此时不会触发 error
    if (!isReady) {
      fallback();
    }
  });
}

/**
 * 注册点击事件监听
 */
function registerActionListener(el) {
  if (judgeCanUseDeepLink()) {
    registerWeixinOpenTag(el);
    return;
  }

  const appType = getAppType();

  let callback = null;
  switch (appType) {
    case 'weixin':
      callback = weixinCallback;
      break;
    case 'qq':
      callback = qqCallback;
      break;
    case 'weibo':
      callback = weiboCallback;
      break;
    default:
      callback = otherCallback;
      break;
  }

  el.addEventListener('click', (e) => {
    if (!el._openProtocolObject) {
      showLog('⚠️ 确保 protocol 已设置！');
      return;
    }
    reportClickOpen(el._openProtocolObject);
    callback(el._openProtocolObject);
    e.preventDefault();
    e.stopPropagation();
  }, true);
}

export function constructProtocolObject(protocol) {
  const protocolObject = parseObjectProtocol(protocol);
  const { open_source, page_identifier } = protocolObject;
  if (!open_source) {
    protocolObject.open_source = window.location.pathname;
  }
  if (page_identifier && typeof page_identifier == 'object') {
    protocolObject.page_identifier = JSON.stringify(page_identifier);
  }
  return protocolObject;
}

export const openAppDirective = {
  inserted(el, binding, vnode) {
    registerActionListener(el);
    const protocol = binding.value?.protocol || vnode.context.$hbShareConfig.getConfig('open-app')?.protocol;
    if (protocol) {
      const protocolObject = constructProtocolObject(protocol);
      el._openProtocolObject = protocolObject;
      reportVisitAction(protocolObject);
      setOpenTagExtinfo(el, protocolObject);
    }
  },
  update(el, binding, vnode) {
    const protocol = binding.value?.protocol || vnode.context.$hbShareConfig.getConfig('open-app')?.protocol;
    if (!protocol) {
      return
    }
    const protocolOld = binding.oldValue?.protocol;
    if (JSON.stringify(protocolOld) !== JSON.stringify(protocol)) {
      const protocolObject = constructProtocolObject(protocol);
      reportVisitAction(protocolObject);
      el._openProtocolObject = protocolObject;
      setOpenTagExtinfo(el, protocolObject);
    }
  }
};
